import React, { Fragment, useEffect, useState } from 'react';
import {
  useListLastCrewDeliveriesQuery,
  useListOpenCrewDeliveriesQuery,
} from '../../../redux/api/crewDeliveryApi';
import { useNavigate, useParams } from 'react-router-dom';
import FormatDateTime from '../../../components/dateTime/FormatDateTime';
import {
  faCircleCheck,
  faCircleXmark,
  faClipboardCheck,
  faUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const ListCrewDeliveries = ({ onlyOpen = false }) => {
  const { lastN } = useParams(); // lastN from URL params is a string, which is fine for Django's <int:last_n>
  const curEvent = useSelector((state) => state.auth.currentEvent);

  const { data: lastDeliveries } = useListLastCrewDeliveriesQuery(
    {
      eventId: curEvent?.id,
      lastN: lastN,
    },
    { skip: !curEvent?.id || !lastN }
  );
  const { data: openDeliveries } = useListOpenCrewDeliveriesQuery(
    { eventId: curEvent?.id },
    { skip: !curEvent?.id || lastN }
  );
  const [deliveries, setDeliveries] = useState(null);

  const navigate = useNavigate();

  const destinationPopover = (names) => {
    return (
      <Popover>
        <Popover.Header as='h3'>Lieferziele</Popover.Header>
        <Popover.Body>
          <ul>
            {names.slice(0, 7).map((name, index) => (
              <li key={index}>{name}</li>
            ))}
            {names.length > 7 && (
              <li key='more'>und {names.length - 7} weitere</li>
            )}
          </ul>
        </Popover.Body>
      </Popover>
    );
  };

  useEffect(() => {
    if (onlyOpen && openDeliveries) {
      setDeliveries(openDeliveries);
    }
    if (!onlyOpen && lastDeliveries) {
      setDeliveries(lastDeliveries);
    }
  }, [lastDeliveries, onlyOpen, openDeliveries]);

  return deliveries && deliveries?.length > 0 ? (
    <Fragment>
      <h4>
        Liste der {deliveries.length} {onlyOpen ? 'offenen' : 'letzten'} Crew
        Lieferungen
      </h4>
      <table className='table table-striped mt-4 align-middle text-start'>
        <thead>
          <tr>
            <th>ID</th>
            <th>angelegt am</th>
            <th>angelegt von</th>
            <th>Details</th>
            <th>bestätigt</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {deliveries.map((delivery, index) => (
            <tr key={index}>
              <td>
                {delivery.counter}
                {delivery.type === 'RET' && (
                  <span className='badge bg-warning text-dark ms-2'>
                    Retoure
                  </span>
                )}
              </td>
              <td>
                <FormatDateTime dateTime={delivery.created_at} />
              </td>
              <td>{delivery.created_by_username}</td>
              <td>
                <ul className='list-unstyled'>
                  <li>
                    <span className='fas fa-location-dot me-2' />
                    <b>
                      {delivery.destination_names.length === 1 ? (
                        delivery.destination_names[0]
                      ) : (
                        <>
                          {delivery.destinations_count} Lieferziele
                          <OverlayTrigger
                            rootClose
                            trigger={['hover', 'focus']}
                            placement='right'
                            overlay={destinationPopover(
                              delivery.destination_names
                            )}
                          >
                            <span className='fas fa-clipboard-list ms-1' />
                          </OverlayTrigger>
                        </>
                      )}
                    </b>
                  </li>
                  <li>
                    <span className='fas fa-dolly me-2' />
                    {delivery.total_planned_quantity}&nbsp;
                    {delivery.total_planned_quantity > 1
                      ? 'Packstücke'
                      : 'Packstück'}
                  </li>
                </ul>
              </td>
              <td>
                <i
                  className={`fas fa-${delivery.confirmed ? 'check' : 'xmark'}`}
                />
              </td>
              <td>
                <button
                  className='ms-3 btn btn-primary btn-sm'
                  onClick={() => navigate(`/crew-delivery/${delivery.id}`)}
                >
                  <FontAwesomeIcon
                    icon={faUpRightFromSquare}
                    className='me-2'
                  />
                  zur Lieferung
                </button>
                {!delivery.confirmed && (
                  <button
                    className='ms-3 btn btn-info btn-sm'
                    onClick={() =>
                      navigate(`/crew-delivery/${delivery.id}/confirm`)
                    }
                  >
                    <FontAwesomeIcon icon={faClipboardCheck} className='me-2' />
                    bestätigen
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Fragment>
  ) : deliveries?.length === 0 ? (
    <div className='alert alert-warning'>Keine Lieferungen gefunden.</div>
  ) : (
    <div className='alert alert-danger'>Fehler beim Laden der Lieferungen.</div>
  );
};

export default ListCrewDeliveries;
